

















import { Vue, Component } from 'vue-property-decorator';
import AppHeader from '../common/header.vue';
import PolicyPopup from '../../dndg/components/policy-popup.vue';

@Component({ components: { AppHeader, PolicyPopup } })
export default class App extends Vue {
    isLoading = false;

    get privacyPopupLink() {
        return { name: 'privacy-policy', query: { popup: true }};
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/home/app.vue